// const dev = "http://localhost:80/api"; // <---- for local development
const dev = "https://uatpostcompapi.ushja.org/api/"; // <--- For UAT
const production = "https://postcompapi.ushja.org/api/";

const isProd = process.env.REACT_APP_ENV === "production";

// const API_URI = isProd ? production : dev;
const API_URI = production;

module.exports = {
  api: API_URI,
  payment_api: process.env.REACT_APP_PAYMENT_API_URI,
};
